// extracted by mini-css-extract-plugin
module.exports = {"button":"HeadButton_button_7ejz4","button--green":"HeadButton_button--green_1Kmfj","button--yellow":"HeadButton_button--yellow_2dnqk","button--red":"HeadButton_button--red_V2tum"};